/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class Track {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object) {
			this.isAvailable = true;

			const pointList:object[] = json['tracks'];
			const pointCount = pointList.length;

			const lastPoint = new TrackPoint(pointList[pointCount - 1], -1, -1, -1);
			this.duration = lastPoint.getElapsedTime();
			this.length = lastPoint.getDistance();

			this.points = [];
			for (let i = 0; i < pointCount; ++i) {
				this.points.push(new TrackPoint(pointList[i], i, this.duration, this.length));
			}

			this.fromDateTime = this.points[0].getDateTime();
			this.toDateTime = lastPoint.getDateTime();

			let prev:TrackPoint = null;
			const elapsedTimeRatios:number[] = [];
			const distanceRatios:number[] = [];
			for (let i = 0; i < pointCount; ++i) {
				const point = this.points[i];
				elapsedTimeRatios.push(point.getElapsedTimeRatio());
				distanceRatios.push(point.getDistanceRatio());

				if (prev) {
					const prevDistance = prev.getDistance();
					const prevTime = prev.getElapsedTime();
					const currentDistance = point.getDistance();
					const currentTime = point.getElapsedTime();
					const speed = (currentDistance - prevDistance) / (currentTime - prevTime) * 3600; // km/h
					prev._setSpeed(speed);
				}
				prev = point;
			}
			this.elapsedTimeRatioSearch = new BinarySearch(elapsedTimeRatios);
			this.distanceRatioSearch = new BinarySearch(distanceRatios);

			this.minSpeed = this.minElevation = Number.MAX_VALUE;
			this.maxSpeed = this.maxElevation = 0;
			for (let i = 0; i < pointCount; ++i) {
				const point = this.points[i];

				if (i < pointCount - 1) {
					const speed = point.getSpeed();
					if (speed < 20) { // TODO: 外れ値除外
						if (speed < this.minSpeed) {
							this.minSpeed = speed;
						} else if (speed > this.maxSpeed) {
							this.maxSpeed = speed;
						}
					}
				}

				const elevation = point.getElevation();
				if (elevation < this.minElevation) {
					this.minElevation = elevation;
				} else if (elevation > this.maxElevation) {
					this.maxElevation = elevation;
				}
			}

			trace('[Track] raw :', json);
			trace('[Track]', this);
		}

		public searchNearestPointByElapsedTimeRatio(elapsedTimeRatio:number):TrackPoint {
			return this.points[this.elapsedTimeRatioSearch.searchNearest(elapsedTimeRatio)];
		}

		public leapNearestPointsByElapsedTimeRatio(elapsedTimeRatio:number):LeapedTrackPoint {
			const result = this.elapsedTimeRatioSearch.leapNearest(elapsedTimeRatio);
			return new LeapedTrackPoint(this.points[result.index0], this.points[result.index1], result.ratio);
		}

		public searchNearestPointByDistanceRatio(distanceRatio:number):TrackPoint {
			return this.points[this.distanceRatioSearch.searchNearest(distanceRatio)];
		}

		public leapNearestPointsByDistanceRatio(distanceRatio:number):LeapedTrackPoint {
			const result = this.distanceRatioSearch.leapNearest(distanceRatio);
			return new LeapedTrackPoint(this.points[result.index0], this.points[result.index1], result.ratio);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsAvailable():boolean {
			return this.isAvailable;
		}

		public getPoints():TrackPoint[] {
			return this.points;
		}

		public getFromDateTime():number {
			return this.fromDateTime;
		}

		public getToDateTime():number {
			return this.toDateTime;
		}

		public getDuration():number {
			return this.duration;
		}

		public getLength():number {
			return this.length;
		}

		public getMinSpeed():number {
			return this.minSpeed;
		}

		public getMaxSpeed():number {
			return this.maxSpeed;
		}

		public getMinElevation():number {
			return this.minElevation;
		}

		public getMaxElevation():number {
			return this.maxElevation;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isAvailable:boolean;

		private points:TrackPoint[];

		private fromDateTime:number;
		private toDateTime:number;

		private duration:number;
		private length:number;

		private elapsedTimeRatioSearch:BinarySearch;
		private distanceRatioSearch:BinarySearch;

		private minSpeed:number;
		private maxSpeed:number;

		private minElevation:number;
		private maxElevation:number;
	}
}
